import ScenarioService from "@/services/scenario.service";
import * as d3 from 'd3';
import createTreeLayout from './createTreeLayout'
import createTreeNode from "@/views/Scenario/draw/createTreeNode";
import createTreeNodeLink from "@/views/Scenario/draw/createTreeNodeLink";
import createBackgroundGrid from "@/views/Scenario/draw/background/createBackgroundGrid";
import createBackgoundDots from "@/views/Scenario/draw/background/createBackgroundDots";

const {NodeType, TypeBackgroundScenario} = ScenarioService


const defaultLayoutConfig = {
    // svg
    margin: {top: 100, right: 16, bottom: 16, left: 16},
    svgWidth: 5000,
    svgHeight: 4000,

    // common node
    paddingNode: 10,
    nodeWidth: 200, // config width của node
    nodeHeight: 41, // config height của node
    nodeRadius: 5, // config radius cho node
    positionTitleText: 'middle',
    yTitleText: 1,

    // title nlp
    yTitleNLP: 33,

    // icon fail/success
    showIconStatus: false,
    xIconStatus: 72,
    yIconStatus: 12,
    sizeIconStatus: 20,

    // layout
    backPointRadius: 7,
    frontPointRadius: 7,
    columnWidth: 240, // config khoảng cách về chiều rộng giữa các node
    rowHeight: 80, // config khoảng cách về chiều cao giữa các node
    iconWidth: 20,
    iconHeight: 20,
    zoom: 100,
    activeId: null,
    focusId: null,
    usePortal: false,
    colorPattern: '#E8E8E8',
    typeBackground: TypeBackgroundScenario.GRID,
}

function createTree(data, containerId, actions, layoutConfig, exceptionMap, nlpSetting, version, onlyShowNodes = null, nodesSuccess = null) {
    for (let i in defaultLayoutConfig) {
        layoutConfig[i] = layoutConfig[i] ? layoutConfig[i] : defaultLayoutConfig[i]
    }
    const root = createTreeLayout({...data, layoutConfig, exceptionMap, onlyShowNodes});
    const {nodeFlowList: dataFlowNodes, nodeOutList: nodes, linkOutList: links, NodeOutMap} = root;

    const PortalSourceMap = {}
    const NodeHasPortal = {}
    const NodeMap = {}
    data.nodeList.forEach(node => {
        NodeMap[node.id] = node
        if (node.type === NodeType.PORTAL) {
            let id = node.config.id
            if (id) {
                let sourceCode = data.nodeList.find(node => node.id === id)
                if (sourceCode) {
                    NodeHasPortal[sourceCode.id] = node
                    PortalSourceMap[node.id] = sourceCode
                }
            }
        }
    })
    let maxX = 0
    let maxY = 0
    nodes.forEach(node => {
        if (node.x > maxX) {
            maxX = node.x
        }
        if (node.y > maxY) {
            maxY = node.y
        }
    })

    let viewBoxWidth = layoutConfig.columnWidth * (maxX + 1)
    let viewBoxHeight = layoutConfig.rowHeight * (maxY + 1)
    // draw tree grid dots
    let svgTreeGrid = d3.select("#svg-tree-grid")
    if (!svgTreeGrid.empty()) {
        d3.select("#svg-tree-grid").remove()
    }

    d3.select("#" + containerId)
        .append("svg")
        .attr("id", "svg-tree-grid")
        .attr("width", "2420")
        .attr("height", "5200")
        .attr("style", () => {
            if (layoutConfig.typeBackground === TypeBackgroundScenario.DOTS) {
                return "padding: 16px"
            } else return "padding: 0px"
        })
    switch (layoutConfig.typeBackground) {
        case TypeBackgroundScenario.GRID:
            createBackgroundGrid(layoutConfig.colorPattern)
            break
        case TypeBackgroundScenario.DOTS:
            createBackgoundDots(layoutConfig.colorPattern)
            break
        default:
            createBackgroundGrid(layoutConfig.colorPattern)
            break
    }


    let svg = d3.select("#svg-" + containerId)
    if (svg.empty()) {
        svg = d3.select("#" + containerId)
            .append("svg")
            .attr("id", "svg-" + containerId)
            .attr("class", "svg-" + containerId)
            .attr('style', 'top:64;left:0;')
            .style("font", "11px Roboto, sans-serif")
            .style("user-select", "none")
    }

    svg
        .attr("width", viewBoxWidth * layoutConfig.zoom / 100)
        .attr("height", viewBoxHeight * layoutConfig.zoom / 100)
        .attr("viewBox", [0, 0, viewBoxWidth, viewBoxHeight])

    let gLink = svg.select('.g-link')
    if (gLink.empty()) {
        gLink = svg.append("g")
            .attr("transform", `translate(${layoutConfig.columnWidth / 2},${layoutConfig.rowHeight / 2})`)
            .attr("fill", "none")
            .attr("class", 'g-link');
    }

    let gNode = svg.select('.g-node-wrapper')
    if (gNode.empty()) {
        gNode = svg.append("g")
            .attr("transform", `translate(${layoutConfig.columnWidth / 2},${layoutConfig.rowHeight / 2})`)
            .attr("cursor", "pointer")
            .attr("pointer-events", "all")
            .attr("class", "g-node-wrapper");
    }

    // Enter any new nodes at the parent's previous position.
    let dataBus = {
        gLink,
        gNode,
        links,
        nodes,
        layoutConfig,
        actions,
        NodeHasPortal,
        NodeMap,
        PortalSourceMap,
        NodeOutMap,
        svg,
        containerId,
        viewBoxWidth,
        viewBoxHeight,
        nlpSetting,
        version,
        onlyShowNodes,
        nodesSuccess
    }
    createTreeNode(dataBus)
    createTreeNodeLink(dataBus)

    return {
        width: viewBoxWidth,
        height: viewBoxHeight,
        dataFlowNodes: dataFlowNodes
    }
}

export default createTree;
